module.exports = __webpack_public_path__ + "static/media/fresh_apple.c7a7bf17.png";